import(/* webpackMode: "eager" */ "/vercel/path0/apps/sanity-docs/app/(user)/forbidden/page.tsx");
